import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusSentToRzd.tsx
const IconApplicationStatusSentToRzd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M1.666 9.167h16.667v7.5a.833.833 0 0 1-.834.833h-15a.833.833 0 0 1-.833-.833zm12.5-6.667h3.333a.833.833 0 0 1 .834.833V7.5H1.666V3.334a.833.833 0 0 1 .833-.834h3.334V.833h1.666V2.5h5V.833h1.667z"
	})]
});
var IconApplicationStatusSentToRzd_default = forwardRef(IconApplicationStatusSentToRzd);
//#endregion
export { IconApplicationStatusSentToRzd_default as default };
